module.exports = __webpack_public_path__ + "static/desktop-air-f8eaa607f98e3ec27f39a1ee877d145f.jpg";